import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import type { ModuleWithProviders } from '@angular/core';
import { NgModule } from '@angular/core';

import type { HttpRequestDataProvider } from './types';

@NgModule({ imports: [], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class RtHttpModule {
  public static forRoot(
    httpRequestDataProvider: HttpRequestDataProvider,
  ): ModuleWithProviders<RtHttpModule> {
    return { ngModule: RtHttpModule, providers: [httpRequestDataProvider] };
  }
}
